// Network IDs disponíveis para Google Ad Manager
export const NETWORKS = [
    { value: '23128820367', label: '23128820367' },
] as const;

export type NetworkValue = typeof NETWORKS[number]['value'];

